import React from 'react';
import Accordion from '../../common/Accordion';
import DataRow from './DataRow';
import { useState } from 'react';
import { TRANSLATIONS } from '../../../constants';
import { useAppSelector, useTranslate } from '../../../hooks/common';
import { currentRoundToString, getInertiaUnit, getPowerUnit, getTorqueUnit, powerRound, speedRoundToString, torqueRoundToString } from '../../../services';

const Motor = () => {
    const translate = useTranslate();
    const mesRequest = useAppSelector(state => state.motor.mesRequest);
    const calculationResponse = useAppSelector(state => state.motor.calculationResponse);
    const [accordionOpen, toggleAccordion] = useState(true);

    const renderMotorDatas = () => {
        if (calculationResponse) {
            const { unitSystem } = mesRequest;
            const { maMn, mk, mn, nN, frequency, temperatureClass, isExEbIICType } = mesRequest.commonData;
            const { startingCurrentRatio, ratedCurrent, noLoadCurrent, motorRatedVoltage } = mesRequest.currentData;
            const { motorInertia } = mesRequest.gearboxData;
            const { mlfb, power } = mesRequest.motorData;
            const { msMn, nsNsyn } = calculationResponse.loadOperationValues;
            const { tStartWarm, tStartCold, tBlockMaxWarm, tBlockMaxCold } = calculationResponse.mesParameters.motorData;
            const powerUnit = getPowerUnit(unitSystem);
            const torqueUnit = getTorqueUnit(unitSystem);
            const inertiaUnit = getInertiaUnit(unitSystem);

            return (
                <>
                    <DataRow
                        value={mlfb}
                        label={translate(TRANSLATIONS.result.motorData.mlfb)}
                    />
                    {power != null && <DataRow
                        value={powerRound(power).toString()}
                        label={translate(TRANSLATIONS.result.motorData.ratedPower)}
                        unit={powerUnit}
                    />}
                    {motorRatedVoltage != null && <DataRow
                        value={motorRatedVoltage}
                        label={translate(TRANSLATIONS.result.motorData.ratedVoltage)}
                        unit='[V]'
                    />}
                    {frequency != null && <DataRow
                        value={frequency}
                        label={translate(TRANSLATIONS.result.motorData.frequency)}
                        unit='[Hz]'
                    />}
                    {ratedCurrent != null && <DataRow
                        value={currentRoundToString(ratedCurrent)}
                        label={translate(TRANSLATIONS.result.motorData.ratedCurrent)}
                        unit='[A]'
                    />}
                    {mn != null && <DataRow
                        value={torqueRoundToString(mn)}
                        label={translate(TRANSLATIONS.result.motorData.ratedTorque)}
                        unit={torqueUnit}
                    />}
                    {nN != null && <DataRow
                        value={speedRoundToString(nN)}
                        label={translate(TRANSLATIONS.result.motorData.ratedSpeed)}
                        unit={translate(TRANSLATIONS.units.rpm)} />}
                    {maMn != null && <DataRow
                        value={maMn && torqueRoundToString(maMn)}
                        label={translate(TRANSLATIONS.result.motorData.relatedLockedRotorTorque)}
                    />}
                    {msMn && <DataRow
                        value={torqueRoundToString(msMn.base)}
                        label={translate(TRANSLATIONS.result.motorData.relatedPullUpTorque)}
                    />}
                    {nsNsyn && <DataRow
                        value={speedRoundToString(nsNsyn.base)}
                        label={translate(TRANSLATIONS.result.motorData.relatedPullUpSpeed)}
                    />}
                    {mk != null && <DataRow
                        value={torqueRoundToString(mk)}
                        label={translate(TRANSLATIONS.result.motorData.relatedBreakdownTorque)}
                    />}
                    {startingCurrentRatio != null && <DataRow
                        value={startingCurrentRatio}
                        label={translate(TRANSLATIONS.result.motorData.relatedLockedRotorCurrent)}
                    />}
                    {noLoadCurrent != null && <DataRow
                        value={currentRoundToString(noLoadCurrent)}
                        label={translate(TRANSLATIONS.result.motorData.noLoadCurrent)}
                        unit='[A]'
                    />}
                    {motorInertia != null && <DataRow
                        value={powerRound(motorInertia)}
                        label={translate(TRANSLATIONS.result.motorData.motorTorqueOfInertia)}
                        unit={inertiaUnit}
                    />}
                    <DataRow
                        value={tStartCold}
                        label={translate(TRANSLATIONS.result.motorData.maxStartUpTimeCold)}
                        unit='[s]'
                    />
                    <DataRow
                        value={tStartWarm}
                        label={translate(TRANSLATIONS.result.motorData.maxStartUpTimeWarm)}
                        unit='[s]'
                    />
                    <DataRow
                        value={tBlockMaxCold}
                        label={translate(TRANSLATIONS.result.motorData.maxBlockingTimeCold)}
                        unit='[s]'
                    />
                    <DataRow
                        value={tBlockMaxWarm}
                        label={translate(TRANSLATIONS.result.motorData.maxBlockingTimeWarm)} unit='[s]'
                    />
                    {isExEbIICType &&
                        <DataRow
                            value={temperatureClass === 1 ?
                                translate(TRANSLATIONS.filters.operationalData.startingConstraints.temperatureClass.T1T2) :
                                translate(TRANSLATIONS.filters.operationalData.startingConstraints.temperatureClass.T3)
                            }
                            label={translate(TRANSLATIONS.filters.operationalData.startingConstraints.temperatureClass.title)}
                        />
                    }
                </>
            );
        }
    };

    return (
        <Accordion
            label={translate(TRANSLATIONS.result.motorData.title)}
            iconFont={'e90c'}
            open={accordionOpen}
            onClick={() => toggleAccordion(!accordionOpen)}
        >
            {renderMotorDatas()}
        </Accordion>
    );
};

export default Motor;
